'use es6';

import { isEmailUnsubscribeUrl } from './urlValidator';
import fetchEmailUnsubscribe from './fetchEmailUnsubscribe';
const startTime = performance.now();
if (isEmailUnsubscribeUrl(window.location.pathname)) {
  fetchEmailUnsubscribe({
    startTime,
    search: window.location.search.substring(1)
  });
}